// Get the redirect URI safely - always use window.location.origin in browser
const getRedirectUri = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  // This should never be reached in an Office Add-in (always runs in browser)
  // but providing production fallback instead of localhost
  return "https://outlook.contravault.com";
};

// Azure AD Configuration for ContraVault Outlook Add-in
const getAuthority = (): string => {
  // Multi-tenant default for work/school accounts. Can be overridden via env if needed.
  return  "https://login.microsoftonline.com/organizations";
};

export const msalConfig = {
  auth: {
    clientId: "c0fef485-1cdb-4e5a-90db-8acd8e7d1850",
    authority: getAuthority(),
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getRedirectUri(),
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage", // Use sessionStorage for better security in Office add-ins
    storeAuthStateInCookie: true, // Required for Office add-ins and IE11 support
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 'Error':
            console.error(message);
            return;
          case 'Info':
            console.info(message);
            return;
          case 'Verbose':
            console.debug(message);
            return;
          case 'Warning':
            console.warn(message);
            return;
        }
      }
    }
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    // Mail.Read removed - not available in current tenant
    // Using Office.js only for email access (current email only)
    "api://c0fef485-1cdb-4e5a-90db-8acd8e7d1850/cv-outlook-add-in"
  ],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
  prompt: "select_account", // This will show account picker
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMessagesEndpoint: "https://graph.microsoft.com/v1.0/me/messages",
};
